"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var IconButton = function IconButton(_ref) {
  var onClick = _ref.onClick,
    Icon = _ref.icon,
    iconProps = _ref.iconProps,
    borderWidth = _ref.borderWidth,
    padding = _ref.padding,
    background = _ref.background,
    bsStyle = _ref.bsStyle,
    bsStyleContainer = _ref.bsStyleContainer,
    hasAction = _ref.hasAction,
    tooltip = _ref.tooltip,
    tooltipConfig = _ref.tooltipConfig;
  var defaultTooltip = _objectSpread(_objectSpread({}, {
    place: 'right',
    type: 'dark',
    effect: 'solid'
  }), tooltipConfig);
  var handleClick = function handleClick(e) {
    return hasAction ? onClick(e) : _noop.default;
  };
  return /*#__PURE__*/_react.default.createElement(_styled.Button, {
    onClick: handleClick,
    $bsStyle: bsStyleContainer
  }, /*#__PURE__*/_react.default.createElement(_styled.Border, {
    width: borderWidth,
    padding: padding,
    $bsStyle: bsStyle,
    background: background,
    "data-for": "icon",
    "data-tip": tooltip
  }, /*#__PURE__*/_react.default.createElement(Icon, iconProps), tooltip && /*#__PURE__*/_react.default.createElement(_styled.StyledReactTooltip, _extends({
    id: "icon"
  }, defaultTooltip, {
    html: true
  }))));
};
IconButton.propTypes = {
  onClick: _propTypes.default.func,
  icon: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.func]),
  iconProps: _propTypes.default.shape({}),
  borderWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  padding: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  background: _propTypes.default.string,
  hasAction: _propTypes.default.bool,
  tooltip: _propTypes.default.string,
  bsStyle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),
  bsStyleContainer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),
  tooltipConfig: _propTypes.default.shape({
    place: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
    type: _propTypes.default.oneOf(['dark', 'success', 'warning', 'error', 'info', 'light']),
    effect: _propTypes.default.oneOf(['float', 'solid'])
  })
};
IconButton.defaultProps = {
  iconProps: {},
  icon: _styled.DefaultIcon,
  borderWidth: '0',
  padding: '0',
  bsStyle: '',
  bsStyleContainer: '',
  hasAction: true,
  background: undefined,
  onClick: undefined,
  tooltip: undefined,
  tooltipConfig: {}
};
var _default = IconButton;
exports.default = _default;